//#region Libraries
import { useNavigate } from 'react-router-dom';
//#endregion
//#region Icons
import ExitIcon from 'icons/ExitIcon';
import PadlockIcon from 'icons/PadlockIcon';
//#endregion
//#region Styles
import { Container, Item } from "./styles";
//#endregion

const Options = ({
    className
}) => {
    //#region Extra
    const navigate = useNavigate();
    //#endregion
    //#region Functions
    const doLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    }
    const getItems = () => {
        return [
            {
                text: "Cambiar contraseña",
                icon: <PadlockIcon/>,
                link: "https://contrasena.utp.edu.pe/"
            },
            {
                text: "Cerrar sesión",
                icon: <ExitIcon/>,
                action: doLogout
            }
        ];
    }
    //#endregion
    return (
        <Container className={className}>
            {getItems().map(({ text, icon, link, action }, idx) => (
                <Item key={idx} onClick={action}>
                    {link 
                    ? <a href={link} target="_blank">
                        {icon}
                        <span>{text}</span>
                    </a>
                    : <div>
                        {icon}
                        <span>{text}</span>
                    </div>}
                </Item>
            ))}
        </Container>
    );
}

export default Options;